import React from 'react';
import {Typography} from '@material-ui/core';
import {Domain} from '../../../graphql/graphql.types';
import {lang} from '../../../lang/lang';

const MAX_VISIBLE = 2;

export const CorporationsRenderer = ({item: {corporations}}: {item: Domain}) => {
    const items = corporations || [];

    return (
        <>
            {items.slice(0, MAX_VISIBLE).map(({id, nameJp, nameEn}) => (
                <div key={id}>
                    <Typography variant="body2">{nameJp}</Typography>
                    {nameEn && <Typography variant="caption" color="textSecondary">{nameEn}</Typography>}
                </div>
            ))}
            {items.length > MAX_VISIBLE && (
                <Typography variant="caption" color="textSecondary">
                    {lang.domain.corporations.more(items.length - MAX_VISIBLE)}
                </Typography>
            )}
        </>
    );
};
